<template>
  <div class="theme-toggle-container">
    <v-btn
      icon
      @click="toggleTheme"
      class="ma-2"
      absolute
      top
      right
      fab
    >
      <v-icon>{{ themeIcon }}</v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'TheHeader',
  computed: {
    themeIcon() {
      return this.$vuetify.theme.global.current.dark ? 'mdi-weather-night' : 'mdi-weather-sunny';
    }
  },
  methods: {
    toggleTheme() {
      this.$vuetify.theme.global.name = this.$vuetify.theme.global.current.dark ? 'light' : 'dark';
    }
  }
}
</script>

<style scoped>
.theme-toggle-container {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 1000;
}
</style>
